export const employerIds = {
	disney: '0628667a-7697-45ea-a43c-2dc700a4fa18',
	jpmc: '3a904898-f632-4464-9ac7-6e3596c18c95',
	tacobellFranchise: '408911ec-2a98-11e7-9b88-032659bbb5d4',
	walmart: '6637b2af-eceb-4de9-8789-82e5b8b36200',
};
